import { ContractorResponse } from "@/models/api/administration/contractors/Contractor";
import { ContractorBankStatementItemResponse } from "@/models/api/administration/contractors/ContractorBankStatementItemResponse";
import { DocumentsWithPaymentsResponse } from "@/models/api/administration/contractors/DocumentsWithPaymentsResponse";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import CancellableHelper from "@/requests/CancellableHelper";

//#region routes
export const URL_GET_CONTRACTORS_PAGED = "/ContractorAdministration/Paged";
export const URL_GET_CONTRACTOR_DOCUMENTS_WITH_PAYMENT =
  "/ContractorAdministration/${ContractorId}/DocumentsWithPayment";
export const URL_GET_CONTRACTOR_BANK_STATEMENT_ITEM = "/ContractorAdministration/${ContractorId}/BankStatement";

//#endregion

const _getContractorsTable = new CancellableHelper<ContractorResponse>(URL_GET_CONTRACTORS_PAGED, ContractorResponse);
_getContractorsTable.jsonSerializer = true;
export const getContractorsTable = async (genericTableRequest: GenericTableRequest): Promise<ContractorResponse> => {
  return await _getContractorsTable.get(genericTableRequest);
};

const _getContractorDocumentsWithPayment = new CancellableHelper<DocumentsWithPaymentsResponse>(
  URL_GET_CONTRACTOR_DOCUMENTS_WITH_PAYMENT,
  DocumentsWithPaymentsResponse
);
_getContractorDocumentsWithPayment.jsonSerializer = true;
export const getContractorDocumentsWithPayment = async (
  genericTableRequest: GenericTableRequest,
  contractorId: string
): Promise<DocumentsWithPaymentsResponse> => {
  return await _getContractorDocumentsWithPayment.get({
    ContractorId: contractorId,
    ...genericTableRequest,
  });
};

const _getContractorBankStatementItem = new CancellableHelper<ContractorBankStatementItemResponse>(
  URL_GET_CONTRACTOR_BANK_STATEMENT_ITEM,
  ContractorBankStatementItemResponse
);
_getContractorBankStatementItem.jsonSerializer = true;
export const getContractorBankStatementItem = async (
  genericTableRequest: GenericTableRequest,
  contractorId: string
): Promise<ContractorBankStatementItemResponse> => {
  return await _getContractorBankStatementItem.get({
    ContractorId: contractorId,
    ...genericTableRequest,
  });
};
